<template>
  <div
    class="arrow-top"
    :class="[`arrow-top--${ direction }`, `arrow-top--${ overlap }`]"
    @click="handleClick"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 42"
      x="0px"
      y="0px"
      style="enable-background:new 0 0 13 66;"
      xml:space="preserve"
    >
      <path
        stroke-width="1.5"
        d="M6.133 41.072V1.627"
      />
      <path
        stroke="none"
        d="M6.134 0L0 6.598 1.1 7.62l5.034-5.417L11.17 7.62l1.098-1.022z"
      />
    </svg>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  props: {
    overlap: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      direction: 'down',
      isVisible: false,
      setDirectionThrottled: throttle(this.setDirection, 100)
    }
  },
  mounted () {
    this.lastScrollPos = window.pageYOffset
    this.setDirection()
    window.addEventListener('scroll', this.setDirectionThrottled.bind(this))
  },
  methods: {
    setDirection () {
      const currentScrollPos = window.pageYOffset
      const isAtTheBeginning = window.pageYOffset <= 1 // Safari 1px
      const isAtTheEnd = window.pageYOffset === document.body.offsetHeight - window.innerHeight
      this.direction = (currentScrollPos >= this.lastScrollPos && !isAtTheEnd) || isAtTheBeginning
        ? 'down'
        : 'up'
      this.lastScrollPos = currentScrollPos
    },
    handleClick () {
      this.$emit('click', this.direction)
    }
  }
}
</script>

<style lang="scss" scoped>
  .arrow-top {
    @include hide-down(md);
    @include center-content;
    position: fixed;
    bottom: 0;
    right: 0;
    cursor: pointer;
    z-index: 99;

    transition: transform .3s,
                opacity .3s;

    &--down {
      transform: rotate(180deg);
    }

    @include media-up(md) {
      bottom: $header-offset;
    }

    @each $breakpoint-name, $space in $grid-space-around {
      @include media-up($breakpoint-name) {
        width: $space;
      }
    }

    @include media-up(xl) {
      right: calc((100% - #{$grid-container-width}) / 2);
    }

    @media (min-width: 1170px) and (max-height: 700px) {
      bottom: 10px;
    }

    svg {
      width: $arrow-width;
      height: $arrow-height;
      fill: #000;
      stroke: #000;
      transition: fill .15s,
                  stroke .15s;
    }

    &--projects svg,
    &--manifest svg,
    &--contact svg {
      fill: #000;
      stroke: #000;
    }

    &--about svg,
    &--hero svg {
      fill: #fff;
      stroke: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Arrow.vue